import { useState, useRef, useCallback } from 'react';
import produce from 'immer';
import { Change, isAnnotationChange } from '../types';

export const useChangeTracker = () => {
  const [changes, setChanges] = useState<Change[]>([]);
  const undoStack = useRef<Change[][]>([]);

  const recordChange = (change: Change) => {
    undoStack.current.push(changes);
    setChanges(
      produce((draft: Change[]) => {
        const currentChangeIndex = draft.findIndex(
          ({ id }) => id === change.id,
        );
        if (currentChangeIndex !== -1) {
          const currentChange = draft[currentChangeIndex];

          // update the change fields
          if (change.rect) currentChange.rect = change.rect;
          if (change.fieldName) currentChange.fieldName = change.fieldName;
          // originalFieldName shouldn't change so don't copy that over

          if (isAnnotationChange(change) && change.deleted) {
            if (isAnnotationChange(currentChange)) {
              // if the annotation was deleted and it exists already in the pdf, mark it for deletion
              currentChange.deleted = change.deleted;
            } else {
              // if the annotation was deleted, but it doesn't exists already in the pdf, delete the change record for adding it
              draft.splice(currentChangeIndex, 1);
            }
          }
        } else {
          draft.push(change);
        }
      }),
    );
  };
  const undoChange = () => {
    const oldChanges = undoStack.current.pop();
    if (oldChanges !== undefined) setChanges(oldChanges);
  };
  // Memoize for callers
  const clearChanges = useCallback(() => {
    setChanges([]);
    undoStack.current = [];
  }, []);

  return { changes, recordChange, undoChange, clearChanges };
};
